module.exports = __webpack_public_path__ + "static/media/edit.aa0b5ae2.svg";